import type { Plugin } from 'vue'

import { TpIcon } from '@tni-plus/components/icon'
import { TpButton } from '@tni-plus/components/button'
import { TpHelp } from '@tni-plus/components/help'

export default [TpButton, TpIcon, TpHelp] as Plugin[]
